import React from "react";
import styles from "./SideNavArrows.module.scss";

export interface SideNavArrowsProps {
  children: React.ReactNode;
  onPrevious?: () => void;
  onNext?: () => void;
  previousLabel?: string;
  nextLabel?: string;
}

const ArrowIcon = () => (
  <svg
    className={styles["side-nav__icon"]}
    width="29"
    height="16"
    viewBox="0 0 29 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M0.292892 7.2929C-0.0976315 7.68342 -0.0976314 8.31659 0.292893 8.70711L6.65686 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928934C7.68054 0.53841 7.04738 0.53841 6.65685 0.928934L0.292892 7.2929ZM29 7L1 7L1 9L29 9L29 7Z"
      fill="currentColor"
    />
  </svg>
);

/**
 * Flèches latérales "précédent / suivant" encadrant le contenu d'une page
 */
export default function SideNavArrows({
  children,
  onPrevious,
  onNext,
  previousLabel = "Précédent",
  nextLabel = "Suivant",
}: SideNavArrowsProps) {
  const renderArrow = (direction: "previous" | "next") => {
    const action = direction === "previous" ? onPrevious : onNext;
    const label = direction === "previous" ? previousLabel : nextLabel;
    return (
      <div className={styles["side-nav__rail"]}>
        <button
          type="button"
          className={`${styles["side-nav__btn"]} ${styles[`side-nav__btn--${direction}`]}`}
          onClick={action}
          disabled={!action}
          title={label}
          aria-label={label}
        >
          <ArrowIcon />
        </button>
      </div>
    );
  };

  return (
    <div className={styles["side-nav"]}>
      {renderArrow("previous")}
      <div className={styles["side-nav__content"]}>{children}</div>
      {renderArrow("next")}
    </div>
  );
}
